var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Video.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
[], 
["title", "image", "is_tablet"], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("title", kwargs.hasOwnProperty("title") ? kwargs["title"] : "video");
frame.set("image", kwargs.hasOwnProperty("image") ? kwargs["image"] : "");
frame.set("is_tablet", kwargs.hasOwnProperty("is_tablet") ? kwargs["is_tablet"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_2 = "";t_2 += "<div class=\"Video\">\n        ";
if(runtime.contextOrFrameLookup(context, frame, "is_tablet")) {
t_2 += "\n            <div class=\"Video-img u-Cover u-Preload\">\n                <img src=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "image"), env.opts.autoescape);
t_2 += "\" alt=\"";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "title")), env.opts.autoescape);
t_2 += "\">\n            </div>\n        ";
;
}
else {
t_2 += "\n            <video class=\"Video-content\" preload=\"auto\" loop=\"loop\">\n                <source src=\"/static/video/";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
t_2 += ".mp4\" type=\"video/mp4\"/>\n                <source src=\"/static/video/";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
t_2 += ".webm\" type=\"video/webm\"/>\n            </video>\n        ";
;
}
t_2 += "\n    </div>";
t_2 += runtime.suppressValue((lineno = 12, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("Video");
context.setVariable("Video", macro_t_1);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["Video.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Video/Video.jinja
// module id = 39
// module chunks = 0